module.exports = __webpack_public_path__ + "assets/img/img189.2e83cabc.png";